import { useEffect, useRef, useState } from "react";

/**
 * Scroll-reveal wrapper. Adds .in-view when element enters viewport.
 * Use with .reveal or .reveal-stagger CSS classes.
 */
const Reveal = ({ children, className = "", stagger = false, threshold = 0.15, ...rest }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    if (!("IntersectionObserver" in window)) {
      setVisible(true);
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold, rootMargin: "0px 0px -80px 0px" }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [threshold]);

  const baseClass = stagger ? "reveal-stagger" : "reveal";
  return (
    <div
      ref={ref}
      className={`${baseClass} ${visible ? "in-view" : ""} ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Reveal;
